import { useEffect } from "react";
import { applyTheme, useThemeStore } from "@/stores/theme.store";

/**
 * Applies the stored preference once on mount and keeps "system" in step with
 * the OS setting while the tab stays open.
 */
export function useThemeEffect(): void {
  const preference = useThemeStore((state) => state.preference);

  useEffect(() => {
    applyTheme(preference);

    if (preference !== "system") return;

    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => applyTheme("system");
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [preference]);
}
